<template>
  <div class="details">
    <div class="sec-block1">
      <div class="title">题目描述</div>
      <div class="abs-btn">
        <div class="btn-txt" @click="hanldeShowDialog">题目列表</div>
        <div class="case-num">
          <span class="num-col">{{ curTopic && curTopic.curIndex }}</span>
          /{{ topicList && topicList.length }}
        </div>
      </div>
    </div>
    <template v-if="dayDetails">
      <itemComponents ref="itemSwitch" :topicList="topicList" :dayDetails="dayDetails" :questionImage="questionImage"
        :questionVideo="questionVideo" :itemIds="itemIds" :trueAnswerId="trueAnswerId" :answerStatus="answerStatus"
        :userAnswer="userAnswer" :answerIsTrue="answerIsTrue" :trueTxt="trueTxt" :analysisVideo="analysisVideo"
        :questionCourses="questionCourses" :questionDocuments="questionDocuments" :questionCases="questionCases"
        @swipe-change="onChange" @image-click="handleClickImgs" @question-video-click="handleClickQuesion"
        @option-click="handleClickItems" @play-video="handlePlayVideo" />
    </template>
    <div class="fix-btn">
      <div class="flex-btn">
        <div class="btn-item" @click="handlePrevTopic">
          <img src="@/assets/images/questionBank/img(9).png" class="item-icon" alt="" />
          <div class="item-txt">上一题</div>
        </div>
        <div class="btn-item" @click="handleNextTopic">
          <img src="@/assets/images/questionBank/img(17).png" class="item-icon" alt="" />
          <div class="item-txt">下一题</div>
        </div>
      </div>
    </div>
    <indexComponents :showAll="showDialog" :topicList="topicList" @update:showAll="showDialog = $event"
      @topic-click="handleClickTopic" />
    <div class="dialog-video" v-if="videoDialog">
      <div class="dialog-video-bg" @click.stop="handlePauseVideo"></div>
      <VideoPlayerAnswer ref="video" :playerVideo="analysisVideo"></VideoPlayerAnswer>
    </div>
    <van-overlay :show="showImage" class="loading-overlay">
      <van-loading type="spinner" />
    </van-overlay>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import {
  stopScroll,
  canScroll,
  debounce,
} from '../../utils/util'
import VideoPlayerAnswer from '@/views/home/components/VideoPlayerAnswer.vue'
// import { getShareInfo } from '@/utils/wxShare'
import withRouteTracking from '@/utils/withRouteTracking'
import itemComponents from '@/components/questionCom/itemComponents.vue'
import indexComponents from '@/components/questionCom/indexComponents.vue'
import {campStudyQuestionList} from '@/api/grade.js'
const UserProfile = {
  components: {
    VideoPlayerAnswer,
    itemComponents,
    indexComponents,
  },
  data () {
    return {
      dayDetails: {},
      questionImage: {},
      questionVideo: {},
      showDialog: false,
      questionOptions: [],
      itemIds: [],
      topicList: [],
      curTopic: {},
      curSwiperIndex: 0,
      answerStatus: '-1',
      // 知识来源课程
      questionCourses: [],
      // 知识来源文献
      questionDocuments: [],
      // 知识来源病例
      questionCases: [],
      // 解析视频
      analysisVideo: {},
      trueTxt: '',
      answerIsTrue: String,
      videoDialog: false,
      userAnswer: [],
      showImage: false,
      showConfirmBtn: false,
      isAnswerBool: false,
      campId: '',
      whichDay: '',
      allQues: [],
      trueAnswerId: [],
    }
  },
  mounted () {
    this.campId = this.$route.query.campId
    this.whichDay = this.$route.query.whichDay
    canScroll()
    this.handleFun()
    window.vueThis = this
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    changeCourseCon() {
      return JSON.parse(sessionStorage.getItem('changeCourseCon'))
    }
  },
  methods: {
    // 跳转到指定题目
    handleClickTopic (index) {
      if (index + 1 === this.curTopic.curIndex) return
      this.resetQuestionState()
      this.$refs.itemSwitch.$refs.vantSwiper.swipeTo(index)
    },

    // 显示/隐藏题目序列号对话框
    hanldeShowDialog () {
      this.showDialog = !this.showDialog
    },

    // 上一题
    handlePrevTopic: debounce(() => {
      const _this = window.vueThis
      if (_this.dayDetails.id === _this.topicList[0].id) {
        _this.$toast('这里是第一题！')
        return
      }
      const prevIndex =
        _this.topicList.findIndex((res) => res.id === _this.dayDetails.id) - 1
      _this.handleClickTopic(prevIndex)
    }, 100),

    // 下一题
    handleNextTopic: debounce((type) => {
      const _this = window.vueThis
      const lastIndex = _this.topicList.length - 1
      if (_this.dayDetails.id === _this.topicList[lastIndex].id) {
        _this.$toast('您已到最后一题！')
        // if (_this.itemIds.length > 0) {
        //   _this.showConfirmBtn = true;
        // }
        if (type === 'submit') {
          _this.hanldeShowDialog()
        }
        return
      }
      const nextIndex =
        _this.topicList.findIndex((res) => res.id === _this.dayDetails.id) + 1
      _this.isAnswerBool = false
      _this.handleClickTopic(nextIndex)
    }, 100),

    // Swiper 切换回调
    onChange (e) {
      this.curSwiperIndex = e
      this.topicList[e].curIndex = e + 1
      this.curTopic = this.topicList[e]
      this.questionId = this.topicList[e].id
      const checkData = this.allQues.data.find(
        (item) => item.id === this.questionId
      )
      this.getQuestionData(checkData)
    },

    // 提交答案
    handleSubmit () {
      if (this.itemIds.length === 0) {
        this.$toast('作题答案不能为空！')
        return
      }
      if (this.dayDetails.questionType === '2' && this.itemIds.length < 2) {
        this.$toast('该题为多选题，请至少选择两个选项！')
        return
      }
      this.handleSubmitCon()
    },
    // 点击图片预览
    handleClickImgs () {
      this.showImage = true
      this.imgToBase64(this.questionImage.url).then((imgUrl) => {
        this.showImage = false
        ImagePreview({ images: [imgUrl], showIndex: false, closeable: true })
      })
    },

    // 点击题目视频播放
    handleClickQuesion () {
      this.analysisVideo = this.dayDetails.questionVideo
      this.videoDialog = true
      stopScroll()
      this.$nextTick(() => {
        this.$refs.video.curVideoPlayer.sectionId =
          this.dayDetails.questionVideoId
        this.$refs.video.player.play()
      })
    },

    // 点击选项
    handleClickItems (id) {
      if (this.answerStatus !== '2') return
      if (this.dayDetails.questionType === '1') {
        this.itemIds = [id]
      } else {
        this.itemIds = this.itemIds.includes(id)
          ? this.itemIds.filter((res) => res !== id)
          : [...this.itemIds, id]
      }
    },

    // 获取题目数据
    async handleFun () {
      const params = { baseType: 2, baseIds: this.changeCourseCon.map(res => res.id), showType: 2 }
      this.allQues = await campStudyQuestionList(params)
      this.questionId = this.allQues.data[this.curSwiperIndex] && this.allQues.data[this.curSwiperIndex].id
      this.topicList = this.allQues.data
      const currentTopic = this.topicList.find((item, index) => item.id === this.questionId)
      if (currentTopic) {
        currentTopic.curIndex = this.curSwiperIndex + 1
        this.$refs.itemSwitch.$refs.vantSwiper.swipeTo(this.curSwiperIndex)
        this.curTopic = currentTopic
      }
      this.getQuestionData(currentTopic)
    },

    // 获取题目详情
    getQuestionData (res) {
      if (!res) {
        this.$toast('暂无题目返回')
        return
      }
      this.dayDetails = res
      window.sessionStorage.setItem('mainId', res.id)
      this.answerStatus = `${res.answerStatus}`
      this.userAnswer = res.userAnswer || []
      this.itemIds =
        this.userAnswer.length > 0 && res.answerStatus !== '2'
          ? this.userAnswer.map((item) => item.questionOption.id).sort()
          : []
      this.questionOptions = res.questionOptions.map((item) => ({
        ...item,
        isCheck: false,
      }))
      this.questionImage = res.questionImage || {}
      this.questionVideo = res.questionVideo || {}
      this.trueAnswerId = res.questionAnswers
        .map((item) => item.optionAnswer.id)
        .sort()
      this.trueTxt = res.questionAnswers
        .map((item) => item.optionAnswer.optionContent)
        .toString()
      this.answerIsTrue = `${JSON.stringify(this.trueAnswerId) === JSON.stringify(this.itemIds)}`
      this.questionCourses = res.questionCourses || []
      this.questionDocuments = res.questionDocuments || []
      this.questionCases = res.questionCases || []
      this.analysisVideo = res.analysisVideo || {}
    },

    // 播放视频
    handlePlayVideo () {
      this.analysisVideo = this.dayDetails.analysisVideo
      this.videoDialog = true
      stopScroll()
      this.$nextTick(() => {
        this.$refs.video.curVideoPlayer.sectionId =
          this.dayDetails.analysisVideo.id
        this.$refs.video.player.play()
      })
    },

    // 暂停视频
    handlePauseVideo () {
      this.videoDialog = false
      canScroll()
      this.$refs.video.player.pause()
    },

    // 图片转 Base64
    async imgToBase64 (url) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        image.src = url
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = image.naturalWidth
          canvas.height = image.naturalHeight
          const ctx = canvas.getContext('2d')
          if (!ctx) return reject(new Error('Canvas context not available'))
          ctx.drawImage(image, 0, 0)
          const base64 = canvas.toDataURL('image/jpeg')
          resolve(base64)
        }
        image.onerror = reject
      })
    },

    // 重置题目状态
    resetQuestionState () {
      this.dayDetails = {}
      this.questionImage = {}
      this.itemIds = []
      this.questionOptions = []
    },
  },
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.details {
  position: relative;
  background-color: #fff;
  padding: 15px;
  padding-bottom: 110px;
  box-sizing: border-box;

  .title {
    font-size: 14px;
    color: #000;
    font-weight: 600;
    padding-left: 8px;
    box-sizing: border-box;
    line-height: 20px;
    position: relative;
    margin-bottom: 8px;

    &::before {
      position: absolute;
      width: 4px;
      left: 0;
      top: 4px;
      height: 12px;
      border-radius: 100px;
      background-color: #EB1700;
      content: "";
    }
  }

  .abs-btn {
    position: absolute;
    right: 20px;
    top: 15px;
    display: flex;
    align-items: center;

    .btn-txt {
      width: 68px;
      height: 24px;
      border-radius: 4px;
      background-color: #EB1700;
      color: #fff;
      font-size: 12px;
      text-align: center;
      line-height: 24px;
      margin-right: 16px;
    }

    .case-num {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      color: #333333;

      .num-col {
        color: #EB1700;
      }
    }
  }

  .div-txt {
    font-size: 14px;
    color: #333333;
    margin-bottom: 8px;
  }

  .fix-btn {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #fff;
    border-top: 1px solid #f1f1f1;
    padding: 8px 10px;
    box-sizing: border-box;
    width: 100vw;
    z-index: 9;

    .btn-txt {
      width: 100%;
      height: 40px;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      line-height: 40px;
      background-color: #EB1700;
      border-radius: 100px;
      margin-bottom: 18px;
    }

    .flex-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btn-item {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .item-icon {
          width: 20px;
          height: 20px;
          display: block;
          margin-bottom: 4px;
        }

        .item-txt {
          font-size: 14px;
          line-height: 16px;
          color: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
}

/deep/ .van-overlay {
  z-index: 9999;

  .wrap {
    width: 320px;
    border-radius: 10px;
    background: #fff;
    position: absolute;
    padding: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;

    .img-wrap {
      width: 80px;
      display: block;
      margin-bottom: 18px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .wrap-txt {
      font-size: 17px;
      line-height: 24px;
      font-weight: 600;
      color: #000000;
      margin-bottom: 15px;
      text-align: center;

      &.wrap-txt2 {
        border-bottom: 1px solid #a9aeb6;
        padding-bottom: 10px;
        box-sizing: border-box;
        text-align: left;
        margin-bottom: 14px;
      }
    }

    .wrap-con {
      border: 1px solid rgba(0, 0, 0, 0.07);
      border-radius: 30px;
      background: rgba(0, 0, 0, 0.02);
      font-size: 14px;
      color: #333;

      .van-cell {
        background: rgba(0, 0, 0, 0.02);
      }
    }

    .wrap-txt3 {
      position: relative;

      &::before {
        content: "*";
        font-size: 17px;
        color: #ff0000;
        width: 9px;
        text-align: center;
        display: inline-block;
      }
    }

    .wrap-con {
      width: 288px;
      margin-left: 50%;
      transform: translateX(-50%);
      color: #666;
      font-size: 16px;
      margin-bottom: 20px;

      .href-txt {
        color: #EB1700;
      }
    }

    .warp-btn {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 8px;
      height: 55px;
      box-sizing: border-box;

      .btn {
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        border-radius: 30pc;
        height: 42px;
        line-height: 42px;

        &.btn1 {
          color: #81766F;
          background: #F1EFED;
        }

        &.btn2 {
          background: #EB1700;
          color: #fff;
        }
      }
    }
  }
}
</style>
<style scoped>
.dialog-video {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.dialog-video-bg {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.6);
}

.player {
  position: relative;
  width: 100%;
  height: 200px;
  top: 50%;
  margin-top: -50%;
  z-index: 99999;
}

.player.isFullPlayer {
  position: static;
  height: auto;
  top: 0;
  margin-top: 0;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/grade/gradeQuestionPreview.vue